import { render, staticRenderFns } from "./GroupListSelection.vue?vue&type=template&id=1500fa56&scoped=true&"
import script from "./GroupListSelection.vue?vue&type=script&lang=ts&"
export * from "./GroupListSelection.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListSelection.vue?vue&type=style&index=0&id=1500fa56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1500fa56",
  null
  
)

export default component.exports